/**
 * What DANI returns when drafting a survey (B-10). Structured output: every
 * field present, nullable instead of optional, no unions — the shape the
 * feasibility intake uses. Turned into a draft only by toDraftContent.
 */
import { z } from 'zod/v4';

export const DANI_QUESTION_TYPES = [
    'single_select',
    'multiple_select',
    'short_answer',
    'number_slider',
    'number_pad',
    'date_picker',
    'matrix',
    'image_display',
] as const;

export const DaniQuestionSchema = z.object({
    id: z.string(),
    text: z.string(),
    type: z.enum(DANI_QUESTION_TYPES),
    options: z.array(z.string()),
    rows: z.array(z.string()),
    randomize: z.boolean(),
    sliderMin: z.number().int().nullable(),
    sliderMax: z.number().int().nullable(),
    sliderMinLabel: z.string().nullable(),
    sliderMaxLabel: z.string().nullable(),
    terminateOn: z.array(z.string()),
    showIf: z.object({ questionId: z.string(), answers: z.array(z.string()) }).nullable(),
});

export const DaniDraftSchema = z.object({
    title: z.string(),
    target: z.number().int().nullable(),
    fieldDays: z.number().int().nullable(),
    incidenceRate: z.number().nullable(),
    mediaCapture: z.boolean().nullable(),
    ageMin: z.number().int().nullable(),
    ageMax: z.number().int().nullable(),
    genders: z.array(z.enum(['male', 'female', 'non_binary'])),
    states: z.array(z.string()),
    questions: z.array(DaniQuestionSchema),
    stated: z.array(z.string()),
    assumptions: z.array(z.string()),
    openQuestions: z.array(z.string()),
});

export type DaniQuestion = z.infer<typeof DaniQuestionSchema>;
export type DaniDraft = z.infer<typeof DaniDraftSchema>;
